import { render, staticRenderFns } from "./VuelvePromoTab.vue?vue&type=template&id=81a100f0&scoped=true&"
import script from "./VuelvePromoTab.vue?vue&type=script&lang=js&"
export * from "./VuelvePromoTab.vue?vue&type=script&lang=js&"
import style0 from "./VuelvePromoTab.vue?vue&type=style&index=0&id=81a100f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a100f0",
  null
  
)

export default component.exports